export enum ThanksPageMessage {
	RequestingAUniverse = 'ReqUniverse',
	RequestingAFeature = 'ReqFeature',
	ReportingABug = 'ReportBug',
}